import { z } from 'zod';

import { zodInvoicesQueryParamsSchema } from '~/data/invoice';

export const validateInvoiceListSearch = z.object({
  limit: zodInvoicesQueryParamsSchema.shape.limit.catch(100),
  orderBy: z.string().min(1).catch('date'),
  page: z.number().int().min(0).default(0).catch(0),
  savedFilterId: z.uuid().optional().catch(undefined),
  sortOrder: zodInvoicesQueryParamsSchema.shape.sortOrder.catch('DESC'),
});

export const defaultInvoiceListSearch = validateInvoiceListSearch.parse({});
